/*eslint-disable */

import {bus} from '@/main';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery');

export default {
  name: 'two-factor-for-data',
  components: {},
  props: ['twoFactorDataID'],
  data () {
    return {
      otp:'',
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    twoFactorOtpVerifySubmit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.isSubmitted = true
          this.$store.dispatch('verifyTwoFactorOtp', {
            otp: this.otp
            // data_file_id:this.twoFactorDataID
          })
            .then((res) => {
              this.downloadFileMethod(res.data.data.algo_data.data_file, res.data.data.algo_data.data_file_name);
              this.isSubmitted = false;
              // if (res.status === 200) {
              //   this.selectedAlgoDataDetailsByIdMethod(this.twoFactorDataID)
              // }
            }).catch((err) => {
              this.isSubmitted = false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      });
    },
    selectedAlgoDataDetailsByIdMethod(dataId){
      this.$store.dispatch('getAllPubAlgoDataListByIdAction',{id:dataId}).then((res)=>{
        this.downloadFileMethod(res.data.data.data_file, res.data.data.data_file_name)
      }).catch((err)=>{

      })
    },
    downloadFileMethod(file,fileName){
      var link = document.createElement('a');
      link.href = file
      link.download =  fileName;
      document.body.appendChild(link);
      link.click();
      this.twoFactorVerifyPopupClosed()
    },
    twoFactorVerifyPopupClosed(){
      this.otp = ''
      bus.$emit('twoFactorVerifedPopupBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
  }
}
